import { makeAutoObservable } from "mobx";
import {
  deletePatientRank,
  getPatientRankById,
  pagingPatientRank,
  saveOrUpdatePatientRank,
  syncPatientRank,
} from "app/services/PatientRank";

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { checkSearchObject } from "app/common/LocalFunction";
import {
  downloadTemplatePatientRank,
  importExcelPatientRank,
} from "app/services/ImportExcelService";

const defaultValue = {
  code: "",
  name: "",
  isUsing: false,
};
export default class PatientRankStore {
  searchObj = new SearchObject();
  pageObj = null;
  selectedObj = defaultValue;
  openFormCreateOrEdit = false;
  openConfirmDelete = false;

  constructor() {
    makeAutoObservable(this);
  }

  pagingObj = async () => {
    return await pagingPatientRank(this.searchObj)
      .then(({ data }) => {
        this.pageObj = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu hạng khách hàng có lỗi");
      });
  };

  handleChangeFormSearch = (searchObj) => {
    this.searchObj = checkSearchObject(this.searchObj, searchObj);
    this.pagingObj();
  };

  handleOpenFormCreateOrEdit = (medicalEquipmentId) => {
    if (Boolean(medicalEquipmentId)) {
      getPatientRankById(medicalEquipmentId).then(({ data }) => {
        this.selectedObj = data;
        this.openFormCreateOrEdit = true;
      });
    } else {
      this.selectedObj = { ...defaultValue };
      this.openFormCreateOrEdit = true;
    }
  };

  saveOrUpdateObj = (medicalEquipment, { setSubmitting }) => {
    saveOrUpdatePatientRank(medicalEquipment)
      .then(() => {
        this.selectedObj = defaultValue;
        toast.success("Lưu thông tin thành công!");
        this.handleClosePopup();
        this.pagingObj();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin có lỗi");
      })
      .finally(() => setSubmitting(false));
  };

  handleDelete = (medicalEquipment) => {
    this.selectedObj = { id: medicalEquipment?.id };
    this.openConfirmDelete = true;
  };

  handleConfirmDelete = async () => {
    return await deletePatientRank(this.selectedObj?.id)
      .then(() => {
        if (
          this.searchObj?.pageIndex > 1 &&
          this.pageObj?.content?.length === 1
        ) {
          this.searchObj.pageIndex -= 1;
        }
        toast.success("Xóa phân loại khách hàng thành công!");
        this.handleClosePopup();
        this.pagingObj();
      })
      .catch((err) => {
        console.error(err);
        toast.error("Xóa phân loại khách hàng có lỗi");
      });
  };

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDelete = false;
  };
  handleDownloadExcelTemplate = async () => {
    try {
      const response = await downloadTemplatePatientRank();

      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "HANG_KHACH_HANG.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error downloading template:", error);
    }
  };

  SubmitExcelPatientRank = (file) => {
    importExcelPatientRank(file)
      .then(() => {
        toast.success("Nhập excel thành công");
        this.searchObj = {
          ...this.searchObj,
          pageIndex: 1,
        };
        this.pagingObj();
      })
      .catch(() => {
        toast.error("Nhập excel thất bại");
      });
  };

  hanleSyncPatientRank = () => {
    syncPatientRank()
      .then(({ data }) => {
        toast.success("Đồng bộ thành công");
      })
      .catch((error) => {
        console.error(error);
        toast.error("Đồng bộ dữ liệu có lỗi");
      });
  };

  resetStore = () => {
    this.searchObj = new SearchObject();
    this.pageObj = null;
    this.selectedObj = defaultValue;
    this.openFormCreateOrEdit = false;
    this.openConfirmDelete = false;
  };
}
